import { Fund } from '@/shared/MwsViewModels';
import { Vue, Component, Prop } from 'vue-property-decorator';
import template from './fund-info-button.vue';
import BaseInfoButton from '../base-info-button/BaseInfoButton';

@Component({
  mixins: [template],
  components: {
    BaseInfoButton,
  },
})
export default class FundInfoButton extends Vue {
  @Prop()
  fund: Fund;
}
